import * as React from 'react';
import ReactSelect from 'react-select';
import { useFiltersContext } from '../../contexts/filters';

interface ISelectOption {
	label: string;
	value: string;
}

const LocationsSelect = () => {
	const { locations, selectedLocation, selectLocation } = useFiltersContext();

	let options = locations.map((location) => {
		return {
			label: location.name,
			value: '' + location.term_id,
		};
	});

	options = [{ label: 'All Locations', value: '' }, ...options];

	const [value, setValue] = React.useState(options[0]);

	const prevValue = React.useRef(options[0].value);
	const handleOnChange = (option: ISelectOption | null) => {
		if (null !== option && prevValue.current !== option.value && selectLocation) {
			setValue(option);
			selectLocation(+option.value);
			prevValue.current = option.value;
		}
	};

	// When filters are reset, set our value back to the first option.
	React.useEffect(() => {
		if (selectedLocation === 0) {
			setValue(options[0]);
		}
	}, [selectedLocation]);

	return (
		<>
			<ReactSelect
				className="pfa-filter-select"
				classNamePrefix="pfa-filter-select"
				placeholder="Select a Location"
				options={options}
				onChange={handleOnChange}
				value={value}
				key="locations"
			/>
		</>
	);
};

LocationsSelect.displayName = 'LocationsSelect';

export default LocationsSelect;
